import { useEffect } from "react";
import styles from "./styles/Loading.module.css";
import React from "react";
import InitialLoading from "./InitialLoading";
import logo from "./styles/images/Logo FINAL 2023 (8) 1.png";
function Loading({ text }) {
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflowY = "auto";
    };
  }, []);
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
      >
        <img
          src={logo}
          alt="logo"
          style={{
            transform: "translateX(-10px)",
          }}
        />
        {/* <div className={styles.logo_container}></div> */}
        <InitialLoading position="relative" />
        <div className={styles.title}>{text}</div>
      </div>
    </div>
  );
}

export default Loading;
